{
	"name": "@atlassian/browser-storage-controls",
	"version": "11.4.0",
	"description": "Package containing utilities and components for collecting and enforcing user preferences on atlassian browser storage (cookies,localstorage, indexedDB etc.)",
	"publishConfig": {
		"registry": "https://packages.atlassian.com/api/npm/npm-remote"
	},
	"repository": "https://bitbucket.org/atlassian/atlassian-frontend-monorepo",
	"author": "Atlassian Pty Ltd",
	"main": "dist/cjs/index.js",
	"module": "dist/esm/index.js",
	"module:es2019": "dist/es2019/index.js",
	"types": "dist/types/index.d.ts",
	"sideEffects": [
		"*.compiled.css"
	],
	"atlaskit:src": "src/index.ts",
	"atlassian": {
		"team": "trust-privacy-controls-eng-team",
		"i18n": true
	},
	"scripts": {
		"webpack-build": "NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js",
		"ak-postbuild": "NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js && cp package.json dist/package.json",
		"test": "node -r esbuild-register build/ci/test-pipeline/scripts/run-test.ts -c packages/policy-platform/browser-storage-controls/jest.config.js"
	},
	"dependencies": {
		"@atlaskit/atlassian-context": "workspace:^",
		"@atlaskit/button": "workspace:^",
		"@atlaskit/checkbox": "workspace:^",
		"@atlaskit/feature-gate-js-client": "workspace:^",
		"@atlaskit/flag": "workspace:^",
		"@atlaskit/form": "workspace:^",
		"@atlaskit/heading": "workspace:^",
		"@atlaskit/icon": "workspace:^",
		"@atlaskit/intl-messages-provider": "workspace:^",
		"@atlaskit/modal-dialog": "workspace:^",
		"@atlaskit/platform-feature-flags": "workspace:^",
		"@atlaskit/primitives": "workspace:^",
		"@atlaskit/react-ufo": "workspace:^",
		"@atlaskit/tokens": "workspace:^",
		"@atlaskit/tooltip": "workspace:^",
		"@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls": "root:*",
		"@atlassian/atl-context": "workspace:^",
		"@atlassian/ufo": "workspace:^",
		"@atlassian/ufo-experimental": "workspace:^",
		"@atlassiansox/analytics-web-client": "workspace:^",
		"@atlassiansox/frontend-feature-encoding": "root:*",
		"@babel/runtime": "root:*",
		"bind-event-listener": "root:*",
		"js-cookie": "root:*",
		"react-error-boundary": "root:*",
		"react-magnetic-di": "root:*"
	},
	"peerDependencies": {
		"react": "^18.2.0",
		"react-dom": "^18.2.0",
		"react-intl": "^5.25.1 || ^6.0.0 || ^7.0.0"
	},
	"devDependencies": {
		"@af/integration-testing": "workspace:^",
		"@af/visual-regression": "workspace:^",
		"@atlaskit/code": "workspace:^",
		"@atlaskit/css": "workspace:^",
		"@atlaskit/docs": "workspace:^",
		"@atlaskit/ssr": "workspace:^",
		"@atlaskit/toggle": "workspace:^",
		"@atlassian/feature-flags-storybook-utils": "workspace:^",
		"@atlassian/feature-flags-test-utils": "workspace:^",
		"@atlassian/multi-entry-tools": "workspace:^",
		"@atlassian/platform-storybook-helpers": "workspace:^",
		"@atlassian/testing-library": "workspace:^",
		"@babel/preset-typescript": "root:*",
		"@storybook/addon-actions": "root:*",
		"@storybook/test": "root:*",
		"@testing-library/react": "root:*",
		"@testing-library/user-event": "root:*",
		"@types/node": "root:*",
		"fake-indexeddb": "root:*",
		"fetch-mock": "root:*",
		"react": "root:*",
		"react-dom": "root:*",
		"react-intl": "root:*",
		"wait-for-expect": "root:*",
		"webpack-cli": "root:*"
	},
	"exports": {
		".": "./src/index.ts",
		"./banner-controls": "./src/controllers/banner-controls/index.ts",
		"./consent-banner": "./src/ui/consent-banner/index.tsx",
		"./consent-banner/preference-modal": "./src/ui/consent-banner/preference-modal/index.tsx",
		"./constants": "./src/constants.ts",
		"./controllers/banner-controls/get-banner-visibility": "./src/controllers/banner-controls/get-banner-visibility/index.ts",
		"./controllers/banner-controls/should-banner-render-prefetched": "./src/controllers/banner-controls/should-banner-render-prefetched/index.ts",
		"./controllers/banner-controls/should-banner-render": "./src/controllers/banner-controls/should-banner-render/index.ts",
		"./controllers/banner-controls/types": "./src/controllers/banner-controls/types.ts",
		"./controllers/cookie-controls/delete-cookie": "./src/controllers/cookie-controls/delete-cookie/index.ts",
		"./controllers/cookie-controls/get-cookie": "./src/controllers/cookie-controls/get-cookie/index.ts",
		"./controllers/cookie-controls/initialize-controls": "./src/controllers/cookie-controls/initialize-controls/index.ts",
		"./controllers/cookie-controls/set-cookie": "./src/controllers/cookie-controls/set-cookie/index.ts",
		"./controllers/cookie-controls/set-cookie/types": "./src/controllers/cookie-controls/set-cookie/types.ts",
		"./controllers/cookie-controls/set-strictly-necessary-cookie": "./src/controllers/cookie-controls/set-strictly-necessary-cookie/index.ts",
		"./controllers/cookie-controls/transformer": "./src/controllers/cookie-controls/transformer/index.ts",
		"./controllers/preferences-controls/get-preferences": "./src/controllers/preferences-controls/get-preferences/index.ts",
		"./controllers/third-party-controls/check-third-party": "./src/controllers/third-party-controls/check-third-party/index.ts",
		"./cookie-controls": "./src/controllers/cookie-controls/index.ts",
		"./core": "./src/common/utils/bsc-global-state/core.ts",
		"./consent-hub-service/types": "./src/services/consent-hub-service/types.ts",
		"./consent-hub-service/utils": "./src/services/consent-hub-service/utils.ts",
		"./i18n/*": {
			"publish": null,
			"default": "./src/i18n/*.ts"
		},
		"./indexed-db-wrapper-service": "./src/services/indexed-db-wrapper-service/index.ts",
		"./indexed-db-wrapper-service/types": "./src/services/indexed-db-wrapper-service/types.ts",
		"./types": "./src/types.ts",
		"./utils/item-processing": "./src/common/utils/item-processing/index.ts",
		"./utils/load-storage-controls-data/constants": "./src/common/utils/load-storage-controls-data/constants.ts",
		"./web-storage-service": "./src/services/web-storage-service/index.ts",
		"./web-storage-service/types": "./src/services/web-storage-service/types.ts"
	},
	"platform-feature-flags": {
		"platform_bsc_auto_detect_perimeter": {
			"type": "boolean"
		},
		"platform.moonjelly.block-unknown-cookies": {
			"type": "boolean"
		},
		"platform_moonjelly_bsc_ssr_killswitch": {
			"type": "boolean"
		},
		"platform_moonjelly_bsc_ui_killswitch": {
			"type": "boolean"
		},
		"platform_moonjelly_bsc_master_killswitch": {
			"type": "boolean"
		},
		"platform_moonjelly_bsc_debug_mode": {
			"type": "boolean"
		},
		"platform_moonjelly_bsc_web_storage_killswitch": {
			"type": "boolean"
		},
		"product-terminology-refresh": {
			"type": "boolean"
		},
		"platform_remove_bsc_overrides": {
			"type": "boolean"
		},
		"platform_bsc_flat_pattern_file_structure": {
			"type": "boolean"
		},
		"platform_bsc_ssr_flat_pattern_file_format": {
			"type": "boolean"
		},
		"platform_bsc_longest_pattern_match_wins": {
			"type": "boolean"
		},
		"platform_bsc_flat_lookup_skip_merge": {
			"type": "boolean"
		},
		"platform_bsc_cleanup_revoked_storage_live_delete": {
			"type": "boolean"
		},
		"platform_bsc_consent_hub_x_origin_app_normalized": {
			"type": "boolean"
		},
		"platform_bsc_browser_extension_detection": {
			"type": "boolean"
		},
		"platform_bsc_consent_bypass_analytics": {
			"type": "boolean"
		},
		"platform_bsc_sync_initialize_controls": {
			"type": "boolean"
		},
		"platform_bsc_use_generated_package_info": {
			"type": "boolean"
		},
		"platform_bsc_add_cdn_file_version_in_events": {
			"type": "boolean"
		},
		"platform_dst_modal-dialog-use-modal-title": {
			"type": "boolean",
			"referenceOnly": true
		}
	}
}
